import { intersect, partial, string, struct } from 'io-ts/Decoder';

import { Id as UserId } from '../../../../../user/Id';

export const Request = intersect(
	struct({
		user: struct({
			id: UserId,
		}),
	})
)(
	partial({
		targetAt: string,
	})
);
